export const QUOTEAPPLIED= 'QUOTEAPPLIED';
